var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28464_22131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33325C11.6827 1.33325 14.6673 4.31792 14.6673 7.99992C14.6673 11.6819 11.6827 14.6666 8.00065 14.6666C4.31865 14.6666 1.33398 11.6819 1.33398 7.99992C1.33398 4.31792 4.31865 1.33325 8.00065 1.33325ZM8.00065 2.66659C6.58616 2.66659 5.22961 3.22849 4.22941 4.22868C3.22922 5.22888 2.66732 6.58543 2.66732 7.99992C2.66732 9.41441 3.22922 10.771 4.22941 11.7712C5.22961 12.7713 6.58616 13.3333 8.00065 13.3333C9.41514 13.3333 10.7717 12.7713 11.7719 11.7712C12.7721 10.771 13.334 9.41441 13.334 7.99992C13.334 6.58543 12.7721 5.22888 11.7719 4.22868C10.7717 3.22849 9.41514 2.66659 8.00065 2.66659ZM10.3573 5.58725C10.477 5.46642 10.6384 5.3959 10.8083 5.39013C10.9783 5.38436 11.1441 5.44378 11.2717 5.55623C11.3993 5.66867 11.4791 5.82564 11.4948 5.995C11.5105 6.16436 11.4608 6.3333 11.356 6.46725L11.3007 6.52992L7.57665 10.2546C7.44955 10.3817 7.2802 10.4576 7.10076 10.4681C6.92133 10.4785 6.74431 10.4227 6.60332 10.3113L6.53932 10.2546L4.70065 8.41592C4.57981 8.29622 4.5093 8.13487 4.50353 7.96489C4.49776 7.7949 4.55718 7.62914 4.66963 7.50153C4.78207 7.37392 4.93904 7.29412 5.1084 7.27845C5.27776 7.26278 5.4467 7.31244 5.58065 7.41725L5.64332 7.47325L7.05798 8.88725L10.358 5.58725H10.3573Z",
    fill: "#101016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28464_22131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveBlack);
export default __webpack_public_path__ + "static/media/approve-black.23e53e392e01d8669b6c2527934aa90f.svg";
export { ForwardRef as ReactComponent };